import React from "react";
import Body from "components/Body";
import Image from "next/image";
import classNames from "lib/classNames";
import { COLORS_MAPPING } from "components/News/NodeNewsPreviewTeaser";

export default function NodeOfficialTeaser({ node }) {
  return (
    <article className="flex flex-col">
      <div className="order-2 flex-1 flex flex-col p-8 lg:p-10 bg-white shadow-spread w-full">
        <h3 className="order-2 text-xl lg:text-2xl font-important font-bold mb-4">
          {node.title}
        </h3>

        <div
          className={classNames(
            "order-1 mb-4 uppercase font-important font-medium tracking-wider text-sm after:content-['/'] after:ml-2",
            node.field_type.field_color
              ? COLORS_MAPPING[node.field_type.field_color]
              : "text-primary"
          )}
        >
          {node.field_type.name}
        </div>

        {node.body && (
          <div className="order-3 prose max-w-none w-full text-sm">
            <Body value={node.body.value} />
          </div>
        )}
      </div>
      {node.field_image?.image_style_uri.portrait && (
        <div className="order-1">
          <figure className="aspect-w-1 aspect-h-1 overflow-hidden">
            {node.field_image?.image_style_uri.portrait && (
              <Image
                src={node.field_image.image_style_uri.portrait}
                {...node.field_image.resourceIdObjMeta}
                layout="fill"
                objectFit="cover"
              />
            )}
          </figure>
        </div>
      )}
    </article>
  );
}

export function NodeOfficialTeaserLarge({ node }) {
  return (
    <article className="flex flex-col lg:flex-row p-8 lg:p-10 bg-white shadow-spread gap-8">
      <div className="order-2 flex-1 flex flex-col w-full">
        <h3 className="order-2 text-xl lg:text-2xl font-important font-bold mb-4">
          {node.title}
        </h3>

        <div
          className={classNames(
            "order-1 mb-4 uppercase font-important font-medium tracking-wider text-sm after:content-['/'] after:ml-2",
            node.field_type.field_color
              ? COLORS_MAPPING[node.field_type.field_color]
              : "text-primary"
          )}
        >
          {node.field_type.name}
        </div>

        {node.body && (
          <div className="order-3 prose max-w-none text-sm">
            <Body value={node.body.value} />
          </div>
        )}
      </div>
      {node.field_image?.image_style_uri.portrait && (
        <div className="order-1 -mt-8 -mx-8 lg:mt-0 lg:mx-0 lg:w-3/12">
          <figure className="aspect-w-1 aspect-h-1 overflow-hidden">
            {node.field_image?.image_style_uri.portrait && (
              <Image
                src={node.field_image.image_style_uri.portrait}
                {...node.field_image.resourceIdObjMeta}
                layout="fill"
                objectFit="cover"
              />
            )}
          </figure>
        </div>
      )}
    </article>
  );
}
